import { defineComponent as _defineComponent } from 'vue'
import { inject, Ref } from 'vue';
import { useRoute, useRouter } from 'vue-router/composables';

import {
  ConclusionStep,
  ContentDisplay,
  Heading,
  ListDisplay,
  ButtonPrimary,
  BaseText
} from '@warrenbrasil/nebraska-web';

import { IInvestmentConclusion } from '@/modules/transaction/services/product-investment';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import InstrumentAvatar from '@/modules/trade/components/InstrumentAvatar/InstrumentAvatar.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'InvestmentCompletedStep',
  setup(__props) {

const router = useRouter();
const route = useRoute();

const investmentConclusion = inject(
  'investmentConclusion'
) as Ref<IInvestmentConclusion>;

function goToProducts() {
  router.push({
    name: 'productsCatalog',
    params: {
      type: route.params.type
    }
  });
}

return { __sfc: true,router, route, investmentConclusion, goToProducts, ConclusionStep, ContentDisplay, Heading, ListDisplay, ButtonPrimary, BaseText, NebraskaColors, InstrumentAvatar }
}

})